var map = {
	"./antamil.jpeg": "7527",
	"./bondhu.jpeg": "666e",
	"./kamalgeeti.jpg": "3151",
	"./majlis.jpg": "c413",
	"./meghpakhi.jpg": "e082",
	"./nanaronge.jpg": "e382",
	"./roddur.jpg": "e84a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cb3";